import { useContext } from 'react';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import EventsChart from './EventsChart';
import DownloadButton from '../../shared/DownloadButton';
import ChartContainer from '../../shared/ChartContainer';
import DropDownButton, { DropDownMenu } from '../../shared/DropDownButton';
import { PageContext } from '../../../context/page-context';
import { useTranslation } from 'react-i18next';

export default function EventsCard() {
    const menus: DropDownMenu[] = [
        { label: 'By Week', value: 'week' },
        { label: 'By Month', value: 'month' },
        { label: 'By Year', value: 'year' }
    ];

    const exportMenus: DropDownMenu[] = [{ label: 'PDF', value: 'pdf' }, { label: 'CSV', value: 'csv' }];
    
    const { isLoaded } = useContext(PageContext);
    
    const { t } = useTranslation();

    return (
        <Grid item={true} xs={12}>
            <FFPaper
                sx={{
                    alignItems: 'stretch',
                    flexDirection: 'row',
                    minHeight: 350,
                }}
            >   
                {isLoaded && <Stack sx={{ width: '99%' }}>
                    <Stack direction="row" spacing={2} sx={{ pt: 2, pr: 2, pb: 1, pl: 2, zIndex: 100 }}>

                        <Title big={true} info="This graph represents the the number of events that have occurred in a given time">Events</Title>

                        <Stack direction="row" spacing={2} sx={{ pr: 1, pb: 1, mb: 1 }}>

                            <DropDownButton
                                boxShadow={false}
                                defaultLabel={t('app_export_data')}
                                color="text.primary"
                                backgroundColor="button.main"
                                fontSize={14}
                                data={exportMenus} />

                            <DownloadButton />

                            <DropDownButton defaultLabel="By Week" fontSize={15} data={menus} color="text.primary" />

                        </Stack>
                    </Stack>

                    <Box sx={{
                        height: 322,
                        width: '100%',
                        paddingBottom: 1,
                        paddingLeft: 5,
                        paddingRight: 5,
                        marginTop: -9,
                        minHeight: 322,
                    }}>
                          <ChartContainer>
                            <EventsChart />
                          </ChartContainer>
                    </Box>
                </Stack> }
               

            </FFPaper>

        </Grid>
    )
}